import { moduloSistema, perfisSistema } from '../config/system';
import PageInicio from '../components/pages/pages-model/PageInicio.vue';
import PageAlterarModuloMenu from '../components/pages/pages-model/PageAlterarModuloMenu.vue';
import PageProfissional from '@/components/pages/pages-profissional/PageProfissional';
import PagePaciente from '@/components/pages/pages-paciente/PagePaciente';
import PagePublicidade from '@/components/pages/pages-publicidade/PagePublicidade';
import PublicidadeView from '@/components/pages/pages-publicidade/PublicidadeView';
import PageHistChamados from '@/components/pages/pages-hist-chamados/PageHistChamados';
import FormCadastrarPublicidade from '@/components/pages/pages-publicidade/FormCadastrarPublicidade';
import FormEditarPublicidade from '@/components/pages/pages-publicidade/FormEditarPublicidade';
import FormProfissionalMilitar from '@/components/pages/pages-profissional/FormProfissionalMilitar';
import FormProfissionalTerceirizado from '@/components/pages/pages-profissional/FormProfissionalTerceirizado';
import FormPacienteMilitar from '@/components/pages/pages-paciente/FormPacienteMilitar';
import FormPacienteDependente from '@/components/pages/pages-paciente/FormPacienteDependente';
import PagePacienteDependente from '@/components/pages/pages-paciente/PagePacienteDependente';
import FormEspecialidade from '@/components/pages/pages-especialidade/FormEspecialidade.vue';
import PageDisponibilizarAgenda from '@/components/pages/pages-agenda/PageDisponibilizarAgenda.vue';
import PageEspecialidade from '@/components/pages/pages-especialidade/PageEspecialidade.vue';
import FormSubEspecialidade from '@/components/pages/pages-sub-especialidade/FormSubEspecialidade';
import PageSubEspecialidade from '@/components/pages/pages-sub-especialidade/PageSubEspecialidade';
import FormBuilder from '@/components/pages/form-builder/FormBuilder';
import FormBuilderQuestions from '@/components/pages/form-builder/FormBuilderQuestions';
import FormBuilderList from '@/components/pages/form-builder/FormBuilderList.vue';
import FormBuilderView from '@/components/pages/form-builder/FormBuilderView';
import FormBuilderQuestionsView from '@/components/pages/form-builder/FormBuilderQuestionsView';
import FormBuilderRespostas from '@/components/pages/form-builder/FormBuilderRespostas.vue';
import PageGerenciamentoSecretaria from '@/components/pages/pages-atendimento/PageGerenciamentoSecretaria';
import PageBloquearAgenda from '@/components/pages/pages-agenda/PageBloquearAgenda.vue';
import PageVisualizarAgenda from '@/components/pages/pages-agenda/PageVisualizarAgenda.vue';
import PageGerenciamentoProfissional from '@/components/pages/pages-atendimento/PageGerenciamentoProfissional';
import PageListarProfissionalAgendar from '@/components/pages/pages-agenda/PageListarProfissionalAgendar.vue';
import FormAgendarAtendimento from '@/components/pages/pages-agenda/FormAgendarAtendimento.vue';
import PageAcompanhamento from '@/components/pages/pages-atendimento/PageAcompanhamento';
import PageListarSecretaria from '@/components/pages/pages-secretaria/PageListarSecretaria.vue';
import FormManterSecretaria from '@/components/pages/pages-secretaria/FormManterSecretaria.vue';
import DashboardRelatorio from '@/components/pages/pages-relatorios/DashboardRelatorio';
import PageRepasseAtendimentoPaciente from '@/components/pages/pages-atendimento/PageRepasseAtendimentoPaciente';
import PageListarAlimento from '@/components/pages/pages-alimento/PageListarAlimento.vue';
import FormManterAlimento from '@/components/pages/pages-alimento/FormManterAlimento.vue';
import PageListarPrazoAudiometria from '@/components/pages/pages-prazo-audiometria/PageListarPrazoAudiometria.vue';
import FormManterPrazoAudiometria from '@/components/pages/pages-prazo-audiometria/FormManterPrazoAudiometria.vue';
import PageListarDepartamento from '@/components/pages/pages-departamento/PageListarDepartamento.vue';
import FormManterDepartamento from '@/components/pages/pages-departamento/FormManterDepartamento.vue';
import PageListarRefeicao from '@/components/pages/pages-refeicao/PageListarRefeicao.vue';
import FormManterRefeicao from '@/components/pages/pages-refeicao/FormManterRefeicao.vue';
import PageListarFinalidade from '@/components/pages/pages-finalidade/PageListarFinalidade.vue';
import FormManterFinalidade from '@/components/pages/pages-finalidade/FormManterFinalidade.vue';
import PageListarHorarioAtendimento from '@/components/pages/pages-horario-atendimento/PageListarHorarioAtendimento.vue';
import FormManterHorarioAtendimento from '@/components/pages/pages-horario-atendimento/FormManterHorarioAtendimento.vue';
import PageListarSetor from '@/components/pages/pages-setor/PageListarSetor.vue';
import FormManterSetor from '@/components/pages/pages-setor/FormManterSetor.vue';
import PageListarVinculoDepartamentoMedico from '@/components/pages/pages-vinculo-departamento-medico/PageListarVinculoDepartamentoMedico.vue';
import FormManterVinculoDepartamentoMedico from '@/components/pages/pages-vinculo-departamento-medico/FormManterVinculoDepartamentoMedico.vue';
import PageProntuarioCSIPM from '@/components/pages/pages-prontuario/PageProntuarioCSIPM';
import PageInclusaoIndicacaoTAF from '@/components/pages/pages-indicacao-taf/PageInclusaoIndicacaoTAF';
import PageParametroTAF from '@/components/pages/pages-parametro-taf/PageParametroTAF';
import FormManterCalculoConceito from '@/components/pages/pages-parametro-taf-calculo-conceito/FormManterCalculoConceito.vue';
import PageListarCalculoConceito from '@/components/pages/pages-parametro-taf-calculo-conceito/PageListarCalculoConceito.vue';
import FormManterCalculoExercicio from '@/components/pages/pages-parametro-taf-calculo-exercicio/FormManterCalculoExercicio';
import PageListarCalculoExercicio from '@/components/pages/pages-parametro-taf-calculo-exercicio/PageListarCalculoExercicio';
import FormManterCalculoMedia from '@/components/pages/pages-parametro-taf-calculo-media/FormManterCalculoMedia.vue';
import PageListarCalculoMedia from '@/components/pages/pages-parametro-taf-calculo-media/PageListarCalculoMedia.vue';
import FormManterCalculoSituacao from '@/components/pages/pages-parametro-taf-calculo-situacao/FormManterCalculoSituacao.vue';
import PageListarCalculoSituacao from '@/components/pages/pages-parametro-taf-calculo-situacao/PageListarCalculoSituacao.vue';
import PageGerarLaudo from '@/components/pages/pages-gerar-laudo/PageGerarLaudo';
import PageListarCategoriaAtendimento from '@/components/pages/pages-categoria-atendimento/PageListarCategoriaAtendimento.vue';
import FormManterCategoriaAtendimento from '@/components/pages/pages-categoria-atendimento/FormManterCategoriaAtendimento.vue';
import FormManterPistaCorrida from '@/components/pages/pista-corrida/FormManterPistaCorrida.vue';
import PageListarPistaCorrida from '@/components/pages/pista-corrida/PageListarPistaCorrida.vue';

const About = { template: '<div>About test</div>' };

const routes = [
  {
    menu: true,
    uniqueKey: 'alterar-modulo',
    icon: 'fa fa-exchange',
    path: '/alterar-modulo',
    name: 'Alterar Módulo',
    component: <PageAlterarModuloMenu />,
    permissions: [perfisSistema.ALL],
  },
  {
    menu: true,
    uniqueKey: 'home',
    icon: 'fa fa-home',
    path: '/home',
    name: 'Inicio',
    component: <PageInicio />,
    permissions: [perfisSistema.ALL],
  },

  {
    menu: true,
    uniqueKey: 'profissional-page',
    icon: 'fa-solid fa-user-doctor',
    path: '/profissional-page',
    name: 'Cadastro Profissional',
    component: <PageProfissional />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'form-profissional-militar',
    path: '/form-profissional-militar',
    name: 'Formulário do Profissional Militar',
    component: <FormProfissionalMilitar />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'form-profissional-militar/edit',
    path: '/form-profissional-militar/edit',
    name: 'Editar Formulário do Profissional Militar',
    component: <FormProfissionalMilitar />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO],
    params: true,
  },

  {
    menu: false,
    uniqueKey: 'form-profissional-terceirizado',
    path: '/form-profissional-terceirizado',
    name: 'Formulário do Profissional Terceirizado',
    component: <FormProfissionalTerceirizado />,
    modulo: 'PSICOLOGIA',
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'form-profissional-terceirizado/edit',
    path: '/form-profissional-terceirizado/edit',
    name: 'Editar Formulário do Profissional Terceirizado',
    component: <FormProfissionalTerceirizado />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO],
    params: true,
  },

  {
    menu: true,
    uniqueKey: 'paciente-page',
    icon: 'fa-solid fa-person-circle-plus',
    path: '/paciente-page',
    name: 'Cadastro Paciente',
    component: <PagePaciente />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
  },
  {
    menu: true,
    uniqueKey: 'gerar-laudo',
    icon: 'fa-solid fa-file',
    path: '/gerar-laudo',
    name: 'Gerar Laudo',
    component: <PageGerarLaudo />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'pagina-consulta-paciente-dependente',
    icon: 'fab fa-accessible-icon',
    path: '/consulta-paciente-dependente',
    name: 'Paciente Dependente',
    component: <PagePacienteDependente />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'formulario-paciente-militar',
    path: '/form-paciente-militar',
    name: 'Formulário do Paciente Militar',
    component: <FormPacienteMilitar />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'editar-formulario-paciente-militar',
    path: '/form-paciente-militar/edit',
    name: 'Editar Formulário do Paciente Militar',
    component: <FormPacienteMilitar />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
    params: true,
  },

  {
    menu: false,
    uniqueKey: 'formulario-dependente',
    path: '/form-paciente-dependente',
    name: 'Formulário do Paciente Dependente',
    component: <FormPacienteDependente />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'editar-formulario-dependente',
    path: '/form-paciente-dependente/edit',
    name: 'Editar Formulário do Paciente Dependente',
    component: <FormPacienteDependente />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
    params: true,
  },

  {
    menu: false,
    uniqueKey: 'edit',
    path: '/edit',
    component: About,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
  },

  {
    menu: false,
    uniqueKey: 'form-especialidade',
    path: '/form-especialidade',
    name: 'Especialidade',
    component: <FormEspecialidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },

  {
    menu: false,
    uniqueKey: 'page-especialidade',
    path: '/page-especialidade',
    name: 'PageEspecialidade',
    component: <PageEspecialidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },

  {
    menu: false,
    uniqueKey: 'sub_especialidade_form',
    path: '/form-sub-especialidade/editar',
    name: 'Editar Sub Especialidades',
    component: <FormSubEspecialidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
    params: true,
  },

  {
    menu: false,
    uniqueKey: 'page-sub-especialidade',
    path: '/page-sub-especialidade',
    name: 'SubPageEspecialidade',
    component: <PageSubEspecialidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },
  {
    menu: false,
    uniqueKey: 'page-form-builder',
    path: '/page-form-builder',
    name: 'Pagina Form Builder',
    component: <FormBuilder />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },
  {
    menu: false,
    uniqueKey: 'edit-page-form-builder',
    path: '/edit-page-form-builder',
    name: 'Pagina Edição Form Builder',
    component: <FormBuilder />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
    params: true,
  },
  {
    menu: false,
    uniqueKey: 'view-page-form-builder',
    path: '/view-page-form-builder',
    name: 'Pagina Visualização Form Builder',
    component: <FormBuilderView />,
    permissions: [perfisSistema.ADM],
    modulo: moduloSistema.CONFIGURACAO,
    params: true,
  },
  {
    menu: false,
    uniqueKey: 'questions-view-form-builder',
    path: '/questions-view-form-builder',
    name: 'Pagina Visualização de Respostas Form Builder',
    component: <FormBuilderQuestionsView />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],

    params: true,
  },
  {
    menu: false,
    uniqueKey: 'questions-form-builder',
    path: '/questions-form-builder',
    name: 'Pagina Questoes Form Builder',
    component: <FormBuilderQuestions />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
    params: true,
  },
  {
    menu: false,
    uniqueKey: 'read-form-builder',
    path: '/read-form-builder',
    name: 'Leitura Form Builder',
    component: <FormBuilderRead />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
    params: true,
  },
  {
    menu: false,
    uniqueKey: 'list-form-builder-respostas',
    path: '/list-form-builder-respostas',
    name: 'Lista respotas',
    component: FormBuilderRespostas,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },
  {
    menu: false,
    uniqueKey: 'list-form-builder',
    path: '/list-form-builder',
    name: 'Lista formularios',
    component: FormBuilderList,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },

  {
    menu: false,
    uniqueKey: 'gerenciamento-secretaria',
    path: '/gerenciamento-secretaria',
    name: 'Gerenciamento de Secretaria',
    component: PageGerenciamentoSecretaria,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },

  {
    menu: false,
    uniqueKey: 'gerenciamento-profissional',
    path: '/gerenciamento-profissional',
    name: 'Gerenciamento de Profissional',
    component: PageGerenciamentoProfissional,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.ALL],
  },
  {
    menu: false,
    uniqueKey: 'agendar-atendimento',
    path: '/agendar-atendimento',
    component: FormAgendarAtendimento,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.PERFIL_SECRETARIA],
    params: true,
  },
  {
    menu: false,
    uniqueKey: 'acompanhamento-paciente',
    path: '/acompanhamento-paciente',
    name: 'Acompanhamento de Paciente',
    modulo: moduloSistema.PSICOLOGIA,
    component: <PageAcompanhamento />,
    permissions: [perfisSistema.ALL],
    params: true,
  },
  {
    menu: false,
    uniqueKey: 'relatorio-dashboard',
    path: '/relatorio-dashboard',
    name: 'Relatório',
    component: DashboardRelatorio,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO],
  },
  {
    menu: false,
    uniqueKey: 'page-repasse-atendimento-paciente',
    path: '/page-repasse-atendimento-paciente',
    name: 'Página de Repasse de Paciente',
    modulo: moduloSistema.PSICOLOGIA,
    component: PageRepasseAtendimentoPaciente,
    permissions: [perfisSistema.PERFIL_PSICOLOGO],
  },
  {
    menu: true,
    uniqueKey: 'secretaria',
    name: 'Secretaria',
    icon: 'fa-solid fa-users',
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ALL, perfisSistema.ADM],
    submenu: [
      {
        menu: true,
        uniqueKey: 'prontuario-csipm',
        icon: 'fa-solid fa-notes-medical',
        path: '/prontuario-csipm',
        name: 'Prontuário CSIPM',
        component: <PageProntuarioCSIPM />,
        permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.ADM],
      },
      {
        menu: true,
        uniqueKey: 'inclusao-indicacao-taf',
        icon: 'fa-solid fa-road',
        path: '/inclusao-indicacao-taf',
        name: 'Inclusão Indicação TAF',
        component: <PageInclusaoIndicacaoTAF />,
        permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO],
      },
    ],
  },
  {
    menu: true,
    uniqueKey: 'atendimento',
    name: 'Atendimento',
    icon: 'fa-solid fa-calendar-plus',
    permissions: [perfisSistema.ALL],
    modulo: moduloSistema.PSICOLOGIA,
    submenu: [
      {
        menu: true,
        uniqueKey: 'agendar',
        path: '/agendar',
        icon: 'fa-solid fa-calendar-check',
        name: 'Agendar',
        component: <PageListarProfissionalAgendar />,
        permissions: [perfisSistema.PERFIL_SECRETARIA, perfisSistema.GERENTE_PSICOLOGO],
      },
      {
        menu: true,
        uniqueKey: 'gerir-profissional',
        path: '/gerir-atendimento-visao-profissional',
        icon: 'fa-solid  fa-user-doctor',
        name: 'Profissional',
        component: <PageGerenciamentoProfissional />,
        permissions: [perfisSistema.PERFIL_PSICOLOGO],
      },
      {
        menu: true,
        uniqueKey: 'gerir-secretaria',
        path: '/gerir-atendimento-visao-secretaria',
        icon: 'fa-solid  fa-briefcase-medical',
        name: 'Secretaria',
        component: <PageGerenciamentoSecretaria />,
        permissions: [perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        uniqueKey: 'repasse',
        path: '/page-repasse-atendimento-paciente',
        icon: 'fa-solid fa-people-arrows',
        name: 'Repasse de Paciente',
        repasse: true,
        component: <PageListarProfissionalAgendar />,
        permissions: [perfisSistema.PERFIL_PSICOLOGO],
      },
    ],
  },
  {
    menu: true,
    name: 'Agenda',
    uniqueKey: 'agenda',
    icon: 'fa-solid fa-calendar-days',
    permissions: [perfisSistema.ALL],
    modulo: moduloSistema.PSICOLOGIA,
    submenu: [
      {
        menu: true,
        uniqueKey: 'disponibizar-agenda',
        path: '/disponibizar-agenda',
        icon: 'fa-solid fa-calendar-plus',
        name: 'Disponibilizar',
        component: <PageDisponibilizarAgenda />,
        permissions: [perfisSistema.PERFIL_PSICOLOGO],
      },
      {
        menu: true,
        uniqueKey: 'bloquear-agenda',
        path: '/bloquear-agenda',
        icon: 'fa-solid fa-calendar-xmark',
        name: 'Bloquear',
        component: <PageBloquearAgenda />,
        permissions: [perfisSistema.PERFIL_PSICOLOGO],
      },
      {
        menu: true,
        uniqueKey: 'visualizar-agenda',
        path: '/visualizar-agenda',
        icon: 'fa-solid fa-list-check',
        name: 'Visualizar',
        component: <PageVisualizarAgenda />,
        permissions: [perfisSistema.PERFIL_PSICOLOGO, perfisSistema.GERENTE_PSICOLOGO],
      },
    ],
  },
  {
    menu: false,
    uniqueKey: 'hist-chamados-page',
    icon: 'fa-solid fa-history',
    path: '/historico-chamados',
    name: 'Hist. Chamados',
    component: <PageHistChamados />,
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.GERENTE_PSICOLOGO, perfisSistema.ADM],
  },

  {
    menu: false,
    uniqueKey: 'publicidade-page',
    icon: 'fa-solid fa-bullhorn',
    path: '/publicidade-page',
    name: 'Publicidade',
    component: <PagePublicidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
  },

  {
    menu: false,
    uniqueKey: 'view-page-publicidade',
    path: '/view-page-publicidade',
    name: 'Página de Visualização de Publicidade',
    component: <PublicidadeView />,
    permissions: [perfisSistema.ADM],
    modulo: moduloSistema.CONFIGURACAO,
    params: true,
  },

  {
    menu: false,
    uniqueKey: 'form-nova-publicidade',
    path: '/form-nova-publicidade',
    name: 'Página de Nova Publicidade',
    component: <FormCadastrarPublicidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
    params: true,
  },

  {
    menu: false,
    uniqueKey: 'form-editar-publicidade',
    path: '/form-editar-publicidade',
    name: 'Editar Publicidade',
    component: <FormEditarPublicidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
    params: true,
  },

  {
    menu: true,
    path: '/relatorio-dashboard',
    icon: 'fa-solid fa-print',
    uniqueKey: 'relatorios',
    name: 'Relatórios',
    modulo: moduloSistema.PSICOLOGIA,
    permissions: [perfisSistema.GERENTE_PSICOLOGO, perfisSistema.ADM],
  },
  {
    menu: false,
    path: '/form-alimentos',
    uniqueKey: 'form-alimentos',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterAlimento />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-categoria-atendimento',
    uniqueKey: 'form-categoria-atendimento',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterCategoriaAtendimento />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-prazos-audiometria',
    uniqueKey: 'form-prazos-audiometria',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterPrazoAudiometria />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-pista-corrida',
    uniqueKey: 'form-pista-corrida',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterPistaCorrida />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-departamento',
    uniqueKey: 'form-departamento',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterDepartamento />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-refeicao',
    uniqueKey: 'form-refeicao',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterRefeicao />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-finalidade',
    uniqueKey: 'form-finalidade',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterFinalidade />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-horario-atendimento',
    uniqueKey: 'form-finalidade',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterHorarioAtendimento />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-setor',
    uniqueKey: 'form-setor',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterSetor />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-vinculo-departamento-medico',
    uniqueKey: 'form-vinculo-departamento-medico',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterVinculoDepartamentoMedico />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/listar-calculo-conceito',
    uniqueKey: 'listar-calculo-conceito',
    icon: 'fa-solid fa-table-list ',
    component: <PageListarCalculoConceito />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-calculo-conceito',
    uniqueKey: 'form-calculo-conceito',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterCalculoConceito />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/listar-calculo-exercicio',
    uniqueKey: 'listar-calculo-exercicio',
    icon: 'fa-solid fa-table-list ',
    component: <PageListarCalculoExercicio />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-calculo-exercicio',
    uniqueKey: 'form-calculo-exercicio',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterCalculoExercicio />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/listar-calculo-media',
    uniqueKey: 'listar-calculo-media',
    icon: 'fa-solid fa-table-list ',
    component: <PageListarCalculoMedia />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-calculo-media',
    uniqueKey: 'form-calculo-media',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterCalculoMedia />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/listar-calculo-situacao',
    uniqueKey: 'listar-calculo-situacao',
    icon: 'fa-solid fa-table-list ',
    component: <PageListarCalculoSituacao />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    menu: false,
    path: '/form-calculo-situacao',
    uniqueKey: 'form-calculo-situacao',
    icon: 'fa-solid fa-table-list ',
    component: <FormManterCalculoSituacao />,
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
  },
  {
    uniqueKey: 'configuracoes-menu',
    menu: true,
    icon: 'fa-solid fa-gear',
    name: 'Configurações',
    modulo: moduloSistema.CONFIGURACAO,
    permissions: [perfisSistema.ADM],
    submenu: [
      {
        menu: true,
        path: '/page-especialidade',
        icon: 'fa-solid  fa-table-list ',
        name: 'Tabela de Especialidade',
        permissions: [perfisSistema.ADM],
      },
      {
        menu: true,
        path: '/page-sub-especialidade',
        icon: 'fa-solid fa-table-list ',
        name: 'Tabela de sub Especialidade',
        permissions: [perfisSistema.ADM],
      },
      {
        menu: true,
        path: '/page-form-builder',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro de Formulário',
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO],
      },
      {
        menu: true,
        path: '/list-form-builder',
        icon: 'fa-solid fa-table-list ',
        name: 'Lista de Formulário',
        permissions: [perfisSistema.ADM],
      },

      {
        menu: true,
        path: '/list-parametro-taf',
        icon: 'fa-solid fa-table-list ',
        name: 'Parâmetros TAF',
        component: <PageParametroTAF />,
        permissions: [perfisSistema.ADM],
      },

      {
        menu: false,
        path: '/form-secretarias',
        uniqueKey: 'form-secretarias',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro de Atendentes',
        component: <FormManterSecretaria />,
        permissions: [perfisSistema.ADM],
      },
      {
        menu: true,
        path: '/list-secretarias',
        uniqueKey: 'list-secretarias',
        icon: 'fa-solid fa-table-list ',
        name: 'Lista de Atendentes',
        component: <PageListarSecretaria />,
        permissions: [perfisSistema.ADM],
      },

      {
        menu: true,
        path: '/listar-alimentos',
        uniqueKey: 'listar-alimentos',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro de Alimentos',
        component: <PageListarAlimento />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        path: '/listar-categoria-atendimento',
        uniqueKey: 'listar-categoria-atendimento',
        icon: 'fa-solid fa-table-list ',
        name: 'Categoria de Atendimento',
        component: <PageListarCategoriaAtendimento />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        path: '/listar-prazos-audiometria',
        uniqueKey: 'listar-prazos-audiometria',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro Prazos Audiometria',
        component: <PageListarPrazoAudiometria />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },

      {
        menu: true,
        path: '/listar-pista-corrida',
        uniqueKey: 'listar-pista-corrida',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro Pista Corrida',
        component: <PageListarPistaCorrida />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },

      {
        menu: true,
        path: '/listar-departamento',
        uniqueKey: 'listar-departamento',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro de Departamento',
        component: <PageListarDepartamento />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        path: '/listar-finalidade',
        uniqueKey: 'listar-finalidade',
        icon: 'fa-solid fa-table-list ',
        name: 'Controle de Finalidade',
        component: <PageListarFinalidade />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        path: '/listar-refeicao',
        uniqueKey: 'listar-refeicao',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro de Refeição',
        component: <PageListarRefeicao />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        path: '/listar-horario-atendimento',
        uniqueKey: 'listar-horario-atendimento',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro Horário Atendimento',
        component: <PageListarHorarioAtendimento />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        path: '/listar-setor',
        uniqueKey: 'listar-setor',
        icon: 'fa-solid fa-table-list ',
        name: 'Cadastro de Setor',
        component: <PageListarSetor />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
      {
        menu: true,
        path: '/listar-vinculo-departamento-medico',
        uniqueKey: 'listar-vinculo-departamento-medico',
        icon: 'fa-solid fa-table-list ',
        name: 'Vínculo Departamento',
        component: <PageListarVinculoDepartamentoMedico />,
        permissions: [perfisSistema.ADM, perfisSistema.GERENTE_PSICOLOGO, perfisSistema.PERFIL_SECRETARIA],
      },
    ],
  },
];

export const getRoutesPermission = (dadosUsuario) => {
  let routesByPermission = [];
  try {
    let perfisUsuario = dadosUsuario.perfisSistemaAtual;
    if (!perfisUsuario) perfisUsuario = [];
    if (!perfisUsuario.includes(perfisSistema.ALL)) perfisUsuario.push(perfisSistema.ALL);
    routes.forEach((route) => {
      if (route.submenu && route.submenu.length) {
        let route_subMenu;
        route.submenu.forEach((routeSubmenu) => {
          if (perfisUsuario.some((r) => routeSubmenu.permissions.includes(r))) {
            if (!route_subMenu) route_subMenu = { ...route, submenu: [] };
            route_subMenu.submenu.push(routeSubmenu);
          }
        });
        if (route_subMenu) {
          routesByPermission.push(route_subMenu);
        }
      } else {
        if (perfisUsuario.some((r) => route.permissions.includes(r))) {
          routesByPermission.push(route);
        }
      }
    });
  } catch (e) {
    console.error(e);
  }

  return routesByPermission;
};

export const isPermissionRoute = (dadosUsuario, route) => {
  let isPermission = false;
  if (dadosUsuario) {
    const routesUserPermission = getRoutesPermission(dadosUsuario);
    routesUserPermission.forEach((routeUserPermission) => {
      //console.log('routeUserPermission', routeUserPermission);
      //console.log('route', route);
      if (routeUserPermission.submenu && routeUserPermission.submenu.length) {
        routeUserPermission.submenu.forEach((routeSubmenu) => {
          if (routeSubmenu.path === route.path) {
            isPermission = true;
          }
        });
      } else if (routeUserPermission.path === route.path) {
        isPermission = true;
      }
    });
  }
  return isPermission;
};

export default routes;
